/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyCategory
 */
export interface CompanyCategory {
    /**
     * company_cate_idに相当
     * @type {string}
     * @memberof CompanyCategory
     */
    id: string;
    /**
     * 企業カテゴリ名
     * @type {string}
     * @memberof CompanyCategory
     */
    name: string;
    /**
     * 受信設定がされているかを表すフラグ
     * @type {boolean}
     * @memberof CompanyCategory
     */
    isReceiving: boolean;
}

export function CompanyCategoryFromJSON(json: any): CompanyCategory {
    return CompanyCategoryFromJSONTyped(json, false);
}

export function CompanyCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isReceiving': json['is_receiving'],
    };
}

export function CompanyCategoryToJSON(value?: CompanyCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_receiving': value.isReceiving,
    };
}

